/**
 * Badge por estado derivado de una búsqueda (TaEstado, shared/ta-metrics.ts).
 * Mismo espíritu que DeviceStatusBadge del inventario: mapa estado → clases.
 */
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { TaEstado } from '@/../../shared/ta-metrics';

const CLASES: Record<TaEstado, string> = {
  Abierta: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  Cerrada: 'bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300',
  Cancelada: 'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300',
  'Stand By': 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  Request: 'bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-300',
  Pipeline: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300',
  Programada: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300',
  Otro: 'bg-gray-100 text-gray-700 dark:bg-muted dark:text-muted-foreground',
};

export function TaEstadoBadge({ estado, className }: { estado: TaEstado; className?: string }) {
  return <Badge variant="outline" className={cn('border-transparent font-medium', CLASES[estado] ?? CLASES.Otro, className)}>{estado}</Badge>;
}
